<template>
  <div>
    <div class="grc-table-container">
      <b-table
        :items="items"
        :fields="fields"
        :busy="loading"
        :sort-by.sync="localSortBy"
        :sort-desc.sync="localSortDesc"
        :tbody-tr-class="tbodyTrClass"
        thead-class="grc-list-header"
        borderless
        hover
        responsive
        show-empty
        :no-local-sorting="serverSorting"
        :empty-text="emptyText"
        @sort-changed="handleSortChanged"
      >
        <template v-for="(_, slotName) in $scopedSlots" #[slotName]="slotProps">
          <slot :name="slotName" v-bind="slotProps"></slot>
        </template>

        <template v-if="!$scopedSlots['table-busy']" #table-busy>
          <div class="text-center py-5">
            <b-spinner></b-spinner>
            <span class="ml-2">{{ busyText }}</span>
          </div>
        </template>

        <template v-if="!$scopedSlots.empty" #empty>
          <div class="text-muted text-center py-5">
            <i class="fas fa-table fa-2x"></i>
            <p class="mt-3 mb-0">{{ emptyText }}</p>
          </div>
        </template>
      </b-table>
    </div>

    <nav v-if="showPagination" class="grc-pagination-nav">
      <b-pagination
        :value="page"
        :total-rows="totalRows"
        :per-page="perPage"
        align="center"
        prev-text="Anterior"
        next-text="Próximo"
        @input="$emit('page-change', $event)"
      ></b-pagination>
    </nav>
  </div>
</template>

<script>
export default {
  name: "GRCListTable",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    fields: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    page: {
      type: Number,
      default: 1,
    },
    totalRows: {
      type: Number,
      default: 0,
    },
    perPage: {
      type: Number,
      default: 10,
    },
    sortBy: {
      type: String,
      default: null,
    },
    sortDesc: {
      type: Boolean,
      default: false,
    },
    tbodyTrClass: {
      type: [Function, String],
      default: null,
    },
    emptyText: {
      type: String,
      default: "Nenhum registro encontrado",
    },
    busyText: {
      type: String,
      default: "Carregando...",
    },
    showPagination: {
      type: Boolean,
      default: true,
    },
    serverSorting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localSortBy: this.sortBy,
      localSortDesc: this.sortDesc,
    };
  },
  watch: {
    sortBy(value) {
      this.localSortBy = value;
    },
    sortDesc(value) {
      this.localSortDesc = value;
    },
  },
  methods: {
    handleSortChanged(sortOptions) {
      this.localSortBy = sortOptions.sortBy || null;
      this.localSortDesc = Boolean(sortOptions.sortDesc);
      this.$emit("sort-changed", {
        sortBy: this.localSortBy,
        sortDesc: this.localSortDesc,
      });
    },
  },
};
</script>

<style scoped>
.grc-table-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
  overflow: hidden;
}

.grc-pagination-nav {
  margin-top: 1.5rem;
}

::v-deep .grc-list-header th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #495057;
  font-size: 0.8rem;
  text-transform: uppercase;
  border: 0;
  white-space: nowrap;
}

::v-deep .grc-list-header th.sortable:hover {
  color: #0056b3;
}

::v-deep tbody tr {
  border-bottom: 1px solid #f1f3f4;
  transition: background-color 0.2s ease-in-out;
}

::v-deep tbody tr:hover {
  background-color: #f8f9fa;
}

::v-deep tbody tr:last-of-type {
  border-bottom: none;
}

::v-deep tbody td {
  border-top: none;
  vertical-align: middle;
  padding: 0.85rem 0.75rem;
}

::v-deep .page-item .page-link {
  border-radius: 6px;
  margin: 0 3px;
  border: 1px solid #e9ecef;
  color: #495057;
  transition: background-color 0.2s, color 0.2s;
}

::v-deep .page-item .page-link:hover {
  background-color: #f0f2f5;
  color: #0056b3;
}

::v-deep .page-item.active .page-link {
  background-color: #007bff;
  border-color: #007bff;
  color: #fff;
}

::v-deep .page-item.disabled .page-link {
  background-color: transparent;
  color: #adb5bd;
}
</style>
